import React from "react";
import { Text } from "atoms/Text";

export const Error = ({ text, classes, ...props }) => (
  <Text
    color="accents.100"
    fontWeight="normal"
    fontSize="1.4rem"
    lineHeight="16px"
    position="absolute"
    left="0%"
    fontFamily="NeometricRegular"
    className={classes}
    {...props}
  >
    {text}
  </Text>
);

export const ErrorMsg = ({ text, classes, ...props }) => (
  <Text
    color="accents.100"
    fontWeight="normal"
    fontSize="1.4rem"
    lineHeight="16px"
    fontFamily="NeometricRegular"
    className={classes}
    {...props}
  >
    {text}
  </Text>
);
